import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface RemainingCharacterProps {
  /**
   * Maximum number of character.
   */
  maximumCharLength: number;
}

interface RemainingCharacterReturn {
  /**
   * Remaining character display message.
   */
  remainingCharMsg: string;
  /**
   * Handler to update the remaining character and plural remarks.
   */
  charactersRemainingHandler: (currentValueLength: number) => void;
}

const useRemainingCharacter = ({
  maximumCharLength,
}: RemainingCharacterProps): RemainingCharacterReturn => {
  const { t } = useTranslation();

  const [charactersRemaining, setCharactersRemaining] = useState({
    num: maximumCharLength,
    pluralMarker: 's',
  });

  const [remainingCharMsg, setRemainingCharMsg] = useState<string>(
    t('components->>CharacterCounting.RemainingCharacter', { charactersRemaining })
  );

  useEffect(() => {
    setRemainingCharMsg(
      t('components->>CharacterCounting.RemainingCharacter', { charactersRemaining })
    );
  }, [charactersRemaining, t]);

  const charactersRemainingHandler = (currentValueLength: number) => {
    const remainingChar = maximumCharLength - currentValueLength;
    setCharactersRemaining({ num: remainingChar, pluralMarker: remainingChar > 1 ? 's' : '' });
  };

  return {
    remainingCharMsg,
    charactersRemainingHandler,
  };
};

export { useRemainingCharacter };
